var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.682 1.431C20.096.389 19.46.197 18.166.124 16.872.036 13.62 0 10.803 0 7.98 0 4.726.036 3.434.123 2.142.197 1.505.387.914 1.43.311 2.471 0 4.265 0 7.421v.011c0 3.143.31 4.949.914 5.979.591 1.042 1.227 1.231 2.52 1.319 1.292.075 4.546.12 7.369.12 2.817 0 6.07-.045 7.364-.119 1.295-.088 1.93-.277 2.516-1.319.61-1.03.917-2.836.917-5.979v-.007-.004c0-3.157-.308-4.95-.918-5.991zM8.1 11.475v-8.1l6.75 4.05-6.75 4.05z",
    transform: "translate(-537 -3438) translate(0 2581) translate(0 662) translate(375 192) translate(162 3.6)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.61d61ef0bd32dcc8dd21fb547b4f9680.svg";
export { ForwardRef as ReactComponent };